<template>
  <a-layout class='index animated fadeIn s_bf'>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="level" label="级别" name="level">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.level" readonly placeholder='请输入级别' disabled />
          </a-col>
          <a-col :span="12">
            <p>系统自动按顺序分配</p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="level_name" label="级别名称" name="level_name">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.level_name" placeholder='请输入级别名称' maxlength="10" />
          </a-col>
          <a-col :span="12">
            <p>最多10个字</p>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="is_sub_dealer" label="下级经销商管理" name="is_sub_dealer">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-radio-group v-model:value="form.is_sub_dealer">
              <a-radio :value="1">
                允许
              </a-radio>
              <a-radio :value="0">
                不允许
              </a-radio>
            </a-radio-group>
            <a-tooltip placement='right'>
              <template #title>允许当前级别的经销商可以添加,查看自己的直属下级经销商
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </a-col>
          <a-col :span="20" v-if='form.is_sub_dealer == 1'>
            <a-row :gutter="16">
              <a-col :span="14">
                <div class="s_flex_ali mt10">
                  <p>经销商编号前缀：</p>
                  <a-input v-model:value="form.dealer_sn_prefix" style='width:300px' placeholder='请输入经销商编号前缀（选填）' />
                </div>
              </a-col>
              <a-col :span="8">
                <p class="mt10">1～3个字符（支持英文、数字） <a-tooltip placement='right'>
                    <template #title>
                      1.为避免下级添加经销商资料时与总部分配的经销商编号起冲突,可设置固定的编号前缀用以区分
                      <br/>
                      2.总部添加此级别的经销商时不受影响;
                      <br/>
                      3.此设置可选，不设置时不加固定前缀
                    </template>
                    <QuestionCircleOutlined class="s_c376" />
                  </a-tooltip>
                </p>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="is_sub_store" label="下级门店管理" name="is_sub_store">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-radio-group v-model:value="form.is_sub_store">
              <a-radio :value="1">
                允许
              </a-radio>
              <a-radio :value="0">
                不允许
              </a-radio>
            </a-radio-group>
            <a-tooltip placement='right'>
              <template #title>允许当前级别的经销商可以添加,管理自己的直属门店,不允许则再经销商后台隐藏“门店管理”菜单
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </a-col>
          <a-col :span="24" v-if='form.is_sub_store == 1'>
            <a-checkbox-group v-model:value="form.store_auth">
              <a-checkbox value="add">添加门店</a-checkbox>
              <a-checkbox value="edit">修改门店</a-checkbox>
              <a-checkbox value="delete">删除门店</a-checkbox>
            </a-checkbox-group>
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item ref="is_deliver_allow" label="防窜货发货管理" name="is_deliver_allow">
        <a-radio-group v-model:value="form.is_deliver_allow">
          <a-radio :value="1">
            允许
          </a-radio>
          <a-radio :value="0">
            不允许
          </a-radio>
        </a-radio-group>
              <a-tooltip placement='right'>
              <template #title>允许表示当前级别的经销商可以给自己的直属下级经销商,直属门店扫描发货
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
      </a-form-item>
      <a-form-item ref="is_store_stock" label="门店库存查看权限" name="is_store_stock">
        <a-radio-group v-model:value="form.is_store_stock">
          <a-radio :value="0">
            只能查看自己的门店
          </a-radio>
          <a-radio :value="1">
            可以查看自己及下一级经销商的门店
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item ref="remark" label="备注" name="remark">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-input v-model:value="form.remark" placeholder='请输入备注' />
          </a-col>
        </a-row>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
        <a-button type="primary" @click="onSubmit">
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-layout>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { ref, reactive, toRefs, inject,onMounted } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import {  dealerLevelAdd,getNowDealerLevel } from "@/api/dealer";
  // 初始化默认筛选项数值
  let defForm = {
  level: "",
  level_name: "",
  is_sub_dealer: 0,
  is_sub_store: 0,
  is_store_stock: 0,
  store_auth: [],
  dealer_sn_prefix: "",
  remark: "",
  is_deliver_allow: 0,
};
  export default {
    name:'dealerTypeAdd',
    components: {
      QuestionCircleOutlined,
    },
    props: {
      
    },
    setup(props,{emit}) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 4 },
        wrapperCol: { span: 16 },
        rules: {
        level_name: [
          {
            required: true,
            message: "请输入级别名称",
          },
          {
            max: 5,
            message: "最多5个字",
          },
        ],
      },
      });
      const ruleForm = ref()
      const getNowLevel = async () => {
        let res = await getNowDealerLevel().then((res) => res.data);
        if (iscode(res)) {
          form.value.level = res.data.level;
        } else {
          message.error(res.msg);
        }
      };
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          let res = await dealerLevelAdd(form.value).then((res) => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            emit('dealerlevelsubmit')
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      onMounted(() => {
      
        getNowLevel();
    });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit
      }
    }
  }
</script>
